
import {
  schema, normalize
} from 'normalizr'

// Define files schema
const filesSchema = new schema.Entity('files')
const filesListSchema = [filesSchema]

export function adaptFilesToStore({ data }) {
  const entries = normalize(data.results, filesListSchema)
  return {
    entries: entries.entities.files,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}
